'use strict';

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement(modalID) {
    if ($('#' + modalID).length !== 0) {
        $('#' + modalID).modal('hide');
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="' + modalID + '" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only">Close Modal</span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

// Generates beta mode modal content based on content type
// content type available: info
function showBetaModal(modalID, contentType) {
    getModalHtmlElement(modalID);
    var modalBody = $('#' + modalID).find('.modal-body');
    modalBody.empty();
    
    var htmlBodyContent;
    if (contentType == 'info') {
        htmlBodyContent = '<div class="betamode"><div class="betamode__body">The new allheart is still in beta and some functionality may be unavailable.</div>';
        htmlBodyContent += '<div class="betamode__footer">For full functionality, visit <a href="https://www.allheart.com">allheart.com</a></div>';
        htmlBodyContent += '</div>';
    }

    if (htmlBodyContent && htmlBodyContent.length > 0) {
        modalBody.html(htmlBodyContent);
        $('#' + modalID).modal('show');
    }
}

function initEntranceModal() {
    var modalID = 'betaEntrance';
    var contentType = 'entrance';
    getModalHtmlElement(modalID);
    var modalBody = $('#' + modalID).find('.modal-body');
    var modalHead = $('#' + modalID).find('.modal-header');
    
    var htmlBodyContent;
    var htmlHeadContent;
    if (contentType == 'info') {
        htmlBodyContent = '<div class="betamode"><div class="betamode__body">The new allheart is still in beta and some functionality may be unavailable.</div>';
        htmlBodyContent += '<div class="betamode__footer">For full functionality, visit <a href="https://www.allheart.com">allheart.com</a></div>';
        htmlBodyContent += '</div>';
    } else if (contentType == 'entrance') {
        // head content
        htmlHeadContent = '<h1 class="betamode-header">Welcome to the NEW allheart!</h1>';

        // body content
        htmlBodyContent = '<div class="betamode"><div class="betamode__body"><p>We’re still in beta, and some functionality may be unavailable.</p><p>Check out our new site and tell us what you think!</p></div>';
        htmlBodyContent += '<button type="button" class="btn btn-primary btn-block js-betamode-close">Shop Now</button>';
        htmlBodyContent += '<div class="betamode__footer">If you need to log into your account or redeem a gift or Rewards, please visit <a href="https://www.allheart.com">allheart.com</a></div>';
        htmlBodyContent += '</div>';
    }

    if (htmlBodyContent && htmlBodyContent.length > 0) {
        modalHead.append(htmlHeadContent);
        modalBody.empty().html(htmlBodyContent);
        $('#' + modalID).modal('show');
    }

    $('.js-betamode-close').on('click', function () {
        $('#' + modalID).modal('hide');
    });
}

function isNewVisitor() {
    if (window.sessionStorage.length && window.sessionStorage.betaEntrance) {
        return false;
    } else {
        // Set session
        sessionStorage.setItem('betaEntrance', true);
        return true;
    }
}

// Remove URLs for content asset links
function removeURLs() {
    var betamodeLinks = $('a.js-betaModeModal');

    if (betamodeLinks && betamodeLinks.length > 0) {
        $.each(betamodeLinks, function (i) {
            $(betamodeLinks[i]).prop('href', '');
        });
    }
}

module.exports = function () {
    // Check if betamode is enabled
    var isBetaMode = $('.page') && $('.page').data('beta') == true ? true : false;

    if (isBetaMode === true) {
        removeURLs();
        $('body').on('click', '.js-betaModeModal', function(e) {
            e.preventDefault();
    
            showBetaModal('betaModeInfo', 'info');
        });

        if (isNewVisitor()) {
            initEntranceModal();
        }
    }
};